import { useEffect, useRef } from "react";

export default function useOnClose(open: boolean, event?: () => any) {
    const previousOpenState = useRef(open);
    useEffect(() => {
        if (!open && previousOpenState.current) event && event();
        previousOpenState.current = open;
    }, [open])
}